import { 
    Pipe, 
    PipeTransform
}                           from "@angular/core";
import { textNumeric }      from "../functions";

@Pipe({ name: "ctmNumeric" })
export class CtmNumericPipe implements PipeTransform {
    transform(value: Number, option = null):string {
        return textNumeric(value, option);
    }
}
  


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/pipes/numeric.pipe.ts